import { PermissionNew } from "../type";

export function addIsEnableIfMissing(
  permissions: PermissionNew[],
): PermissionNew[] {
  permissions.forEach((permission) => {
    if (!("isEnable" in permission)) {
      permission.isEnable = false; // Add isEnable property with default value false
    }

    if (permission.children && permission.children.length > 0) {
      addIsEnableIfMissing(permission.children);
    }
  });

  return permissions;
}
